
interface LiveAuctionsProps {
  showAll?: boolean;
}

export default function LiveAuctions({ showAll = false }: LiveAuctionsProps) {
  const auctions = [
    {
      id: 1,
      title: 'لامبورغيني أفينتادور 2022',
      category: 'سيارات',
      currentPrice: '850,000 ر.ق',
      timeLeft: { hours: 2, minutes: 45, seconds: 26 },
      bidders: 12,
      image: 'https://www.soumqatar.com/uploads/auctions/lamborghini-aventador-2022.jpg',
      isLive: true
    },
    {
      id: 2,
      title: 'فيلا فاخرة في الخليج الغربي',
      category: 'عقارات',
      currentPrice: '2,500,000 ر.ق',
      timeLeft: { hours: 8, minutes: 15, seconds: 42 },
      bidders: 8,
      image: 'https://www.soumqatar.com/uploads/auctions/luxury-villa-west-bay.jpg',
      isLive: true
    },
    {
      id: 3,
      title: 'يخت فاخر 45 قدم',
      category: 'سفن',
      currentPrice: '1,200,000 ر.ق',
      timeLeft: { hours: 1, minutes: 30, seconds: 15 },
      bidders: 6,
      image: 'https://www.soumqatar.com/uploads/auctions/luxury-yacht-45ft.jpg',
      isLive: true
    },
    {
      id: 4,
      title: 'ساعة رولكس ديتونا ذهبية',
      category: 'ساعات',
      currentPrice: '180,000 ر.ق',
      timeLeft: { hours: 4, minutes: 20, seconds: 8 },
      bidders: 15,
      image: 'https://www.soumqatar.com/uploads/auctions/rolex-daytona-gold.jpg',
      isLive: true
    }
  ];

  const displayedAuctions = showAll ? auctions : auctions.slice(0, 2);

  return (
    <div className="px-4 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold">المزادات النشطة</h3>
        {!showAll && (
          <button className="text-yellow-400 text-sm font-medium">عرض الكل</button>
        )}
      </div>
      
      <div className="space-y-4">
        {displayedAuctions.map((auction) => (
          <div key={auction.id} className="bg-gray-900 rounded-xl overflow-hidden">
            <div className="relative">
              <img
                src={auction.image}
                alt={auction.title}
                className="w-full h-48 object-cover object-top"
                onError={(e) => {
                  // Fallback images
                  const target = e.target as HTMLImageElement;
                  const fallbackImages: { [key: number]: string } = {
                    1: 'https://public.readdy.ai/ai/img_res/b1d774a89d1b11cd94dac106a659afbc.jpg',
                    2: 'https://readdy.ai/api/search-image?query=Luxury%20modern%20villa%20exterior%20with%20pool%2C%20premium%20architecture%2C%20elegant%20design%2C%20high-end%20real%20estate%2C%20professional%20property%20photography%2C%20sophisticated%20lighting%2C%20contemporary%20luxury%20home%2C%20beautiful%20landscaping&width=343&height=200&seq=auction2&orientation=landscape',
                    3: 'https://readdy.ai/api/search-image?query=Luxury%20yacht%2045%20feet%20on%20blue%20ocean%2C%20premium%20boat%20photography%2C%20elegant%20marine%20vessel%2C%20high-end%20yacht%20design%2C%20professional%20nautical%20photography%2C%20sophisticated%20lighting%2C%20modern%20luxury%20boat%2C%20beautiful%20seascape&width=343&height=200&seq=auction3&orientation=landscape',
                    4: 'https://readdy.ai/api/search-image?query=Luxury%20Rolex%20Daytona%20gold%20watch%2C%20premium%20timepiece%20photography%2C%20elegant%20watch%20design%2C%20high-end%20luxury%20accessories%2C%20professional%20product%20photography%2C%20sophisticated%20lighting%2C%20golden%20luxury%20watch%2C%20beautiful%20craftsmanship&width=343&height=200&seq=auction4&orientation=landscape'
                  };
                  target.src = fallbackImages[auction.id] || fallbackImages[1];
                }}
              />
              
              {auction.isLive && (
                <div className="absolute top-3 right-3 bg-red-500 text-white px-2 py-1 rounded-full text-xs font-medium flex items-center">
                  <div className="w-1.5 h-1.5 bg-white rounded-full ml-1 animate-pulse"></div>
                  مباشر
                </div>
              )}
              
              <div className="absolute top-3 left-3 bg-black/70 text-white px-2 py-1 rounded-full text-xs">
                {auction.category}
              </div>
              
              <button className="absolute bottom-3 left-3 w-8 h-8 bg-black/70 rounded-full flex items-center justify-center">
                <i className="ri-heart-line text-white"></i>
              </button>
            </div>
            
            <div className="p-4">
              <h4 className="font-semibold mb-2">{auction.title}</h4>
              
              <div className="flex items-center justify-between mb-3">
                <div>
                  <p className="text-xs text-gray-400 mb-1">السعر الحالي</p>
                  <p className="text-lg font-bold text-yellow-400">{auction.currentPrice}</p>
                </div>
                
                <div className="text-left">
                  <p className="text-xs text-gray-400 mb-1">الوقت المتبقي</p>
                  <div className="flex items-center space-x-1 space-x-reverse">
                    <span className="bg-gray-800 px-2 py-1 rounded text-xs font-mono">
                      {auction.timeLeft.hours.toString().padStart(2, '0')}
                    </span>
                    <span className="text-xs">:</span>
                    <span className="bg-gray-800 px-2 py-1 rounded text-xs font-mono">
                      {auction.timeLeft.minutes.toString().padStart(2, '0')}
                    </span>
                    <span className="text-xs">:</span>
                    <span className="bg-gray-800 px-2 py-1 rounded text-xs font-mono">
                      {auction.timeLeft.seconds.toString().padStart(2, '0')}
                    </span>
                  </div>
                </div>
              </div>
              
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <i className="ri-user-line text-gray-400 ml-1"></i>
                  <span className="text-sm text-gray-400">{auction.bidders} مزايد</span>
                </div>
                <button className="bg-yellow-400 text-black px-6 py-2 rounded-full font-semibold text-sm">
                  زايد الآن
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
